module.exports = __webpack_public_path__ + "static/media/Portraits Over Gchat.f0ad46fc.jpg";